export const REQUEST_TRANSACTIONS = 'transactions/REQUEST_TRANSACTIONS';
export const RECEIVE_TRANSACTIONS = 'transactions/RECEIVE_TRANSACTIONS';
export const LOGOUT = 'transactions/LOGOUT';


